import { render, staticRenderFns } from "./404NotFound.vue?vue&type=template&id=359512eb&scoped=true&"
import script from "./404NotFound.vue?vue&type=script&lang=js&"
export * from "./404NotFound.vue?vue&type=script&lang=js&"
import style0 from "./404NotFound.vue?vue&type=style&index=0&id=359512eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359512eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VContainer,VImg})
